import Cross from '@ori-ui/icons/lib/Cross';
import { jsx as _jsx } from "react/jsx-runtime";
const MuiAutocomplete = {
  closeIcon: /*#__PURE__*/_jsx(Cross, {
    fontSize: "small"
  })
};
export default MuiAutocomplete;